module.exports = __webpack_public_path__ + "static/media/verlauf.4b310949.png";